// styles and images
import { projectStore } from "../../store/Store";

// style and assets
import "./Project.css";
import AddRs from "../../assets/add_card.svg";
import Trash from "../../assets/delete.svg";
import Edit from "../../assets/edit.svg";

// components
import Dates from "../../components/Dates";

export default function ProjectTotals({
  setAddProjectRsTrigger,
  setEditId,
  setDeleteTrigger,
  setDeleteFields,
}) {
  // global
  const projectTotals = projectStore((data) => data.projectTotals);
  const projectRateSheets = projectStore((data) => data.projectRateSheets);
  const setProjectRateSheets = projectStore(
    (data) => data.setProjectRateSheets,
  );
  const setProjectLoads = projectStore((data) => data.setProjectLoads);
  const currentProject = projectStore((data) => data.currentProject);

  const handleEdit = (id) => {
    setEditId(id);
    setAddProjectRsTrigger(true);
  };

  const handleDelete = (id) => {
    setDeleteTrigger(true);
    setDeleteFields({
      setTrigger: setDeleteTrigger,
      id,
      endpoint: "project-rate-sheet",
      table: "project_rate_sheets_tbl",
      nameField: "rs_name",
      setStates: [setProjectRateSheets, setProjectLoads],
      setStateFields: ["project_rate_sheets", "project_loads"],
    });
  };

  return (
    <div className="col-4">
      <div className="p-2 border text-center project-card">
        <div className="d-flex justify-content-between project-header">
          <h5>Job Details</h5>
          <img
            src={AddRs}
            alt="add_rs"
            onClick={() => setAddProjectRsTrigger(true)}
            className="project-delete-image"
          />
        </div>
        {projectTotals && (
          <div className="project-card-list">
            <table className="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Freight Loads</th>
                  <th>Sand Loads</th>
                  <th>Asset Loads</th>
                  <th>Active Days</th>
                  <th>Freight Weight (tons)</th>
                  <th>Sand Weight (tons)</th>
                  <th>Average Weight (tons)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {projectTotals.project_totals.total_freight_loads.toLocaleString(
                      "en-US",
                    )}
                  </td>
                  <td>
                    {projectTotals.project_totals.total_sand_loads.toLocaleString(
                      "en-US",
                    )}
                  </td>
                  <td>
                    {projectTotals.project_asset_totals.total_freight_loads.toLocaleString(
                      "en-US",
                    )}
                  </td>
                  <td>{projectTotals.project_totals.active_days}</td>
                  <td>
                    {projectTotals.project_totals.weight_freight_tons.toLocaleString(
                      "en-US",
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                    )}
                  </td>
                  <td>
                    {projectTotals.project_totals.weight_sand_tons.toLocaleString(
                      "en-US",
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                    )}
                  </td>
                  <td>
                    {projectTotals.project_totals.average_weight_tons.toFixed(
                      2,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            {projectRateSheets && (
              <div>
                <h3>Project Rate Sheets</h3>
                <table>
                  <thead>
                    <tr>
                      <th>Company Name</th>
                      <th>Rate Sheet</th>
                      <th>Rate Sheet Type</th>
                      <th>Start Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {projectRateSheets &&
                      projectRateSheets.map((rs, idx) => (
                        <tr key={`${idx}-freight`}>
                          <td>
                            {rs.carrier_name !== ""
                              ? rs.carrier_name
                              : rs.company_name}
                          </td>
                          <td>{rs.rs_name}</td>
                          <td>{rs.is_fsc ? "FSC" : "Freight"}</td>
                          <Dates d={rs.start_date} />
                          {!currentProject.project.archived && (
                            <td className="action">
                              <div className="d-flex justify-content-between">
                                <img
                                  src={Edit}
                                  className="edit"
                                  onClick={() => handleEdit(rs.id)}
                                  alt="edit"
                                />
                                <img
                                  src={Trash}
                                  className="edit"
                                  onClick={() => handleDelete(rs.id)}
                                  alt="delete"
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
